import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "row",
  style: {"padding":"0 16px"}
}
const _hoisted_2 = { class: "col" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("1000")
const _hoisted_4 = { class: "col" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("1000")
const _hoisted_6 = {
  key: 0,
  class: "row",
  style: {"padding":"0 16px"}
}
const _hoisted_7 = { class: "col" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Trip Details Here")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f7_block_title = _resolveComponent("f7-block-title")
  const _component_f7_card = _resolveComponent("f7-card")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_f7_card, {
          title: "Monthly Progress",
          padding: false
        }, {
          default: _withCtx(() => [
            (!_ctx.rewardsStore.isLoading)
              ? (_openBlock(), _createBlock(_component_f7_block_title, {
                  key: 0,
                  large: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.formatNumber(_ctx.rewardsStore.monthlyPoints)), 1)
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_f7_block_title, {
                  key: 1,
                  large: "",
                  class: "skeleton-text skeleton-effect-wave"
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_f7_card, {
          title: "Total Points",
          padding: false
        }, {
          default: _withCtx(() => [
            (!_ctx.rewardsStore.isLoading)
              ? (_openBlock(), _createBlock(_component_f7_block_title, {
                  key: 0,
                  large: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.formatNumber(_ctx.rewardsStore.totalPoints)), 1)
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_f7_block_title, {
                  key: 1,
                  large: "",
                  class: "skeleton-text skeleton-effect-wave"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        })
      ])
    ]),
    (_ctx.showTripPreview)
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_f7_card, {
              title: "Trip Preview",
              padding: "false",
              class: "no-margin-top"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_f7_block_title, { large: "" }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}